import React from 'react';
import { Badge, Empty, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { LIGHT_COLORS } from '../constants';
import type { WarehouseScoreItem } from '../types';

const { Text } = Typography;

interface Props {
    items: WarehouseScoreItem[];
    selectedWarehouseId?: number;
    attributedWarehouseIds: Set<number>;
    onSelect: (item: WarehouseScoreItem) => void;
}

const WarehouseRankingList: React.FC<Props> = ({ items, selectedWarehouseId, attributedWarehouseIds, onSelect }) => {
    const { t } = useTranslation();
    const I18N = 'dashboard.dailyMeeting';

    if (items.length === 0) {
        return <Empty description={t(`${I18N}.ranking.empty`)} />;
    }

    return (
        <div>
            {items.map((item, index) => {
                const selected = item.warehouseId === selectedWarehouseId;
                return (
                    <div
                        key={item.warehouseId}
                        onClick={() => onSelect(item)}
                        className={`flex items-center gap-3 px-3 py-2 cursor-pointer border-b border-gray-100 ${selected ? 'bg-blue-50' : 'hover:bg-gray-50'}`}
                    >
                        <Text type="secondary" className="w-6 text-right">{index + 1}</Text>
                        <Badge color={LIGHT_COLORS[item.light]} />
                        <div className="flex-1 min-w-0">
                            <div className="truncate">
                                <Text strong>{item.warehouseName}</Text>
                                <Text type="secondary" className="ml-2">{item.hubName}</Text>
                            </div>
                            <Text type="secondary" className="text-xs">
                                {t(`${I18N}.ranking.arrivals`, { value: Number(item.actualArrivals).toLocaleString() })}
                            </Text>
                        </div>
                        {attributedWarehouseIds.has(item.warehouseId) && (
                            <Tag color="success">{t(`${I18N}.ranking.attributed`)}</Tag>
                        )}
                        <Text strong style={{ color: LIGHT_COLORS[item.light] }}>
                            {item.totalScore.toFixed(1)}
                        </Text>
                    </div>
                );
            })}
        </div>
    );
};

export default WarehouseRankingList;
